// Get only the last digits of a string
export const getLastDigits = (str: string, n: number) => {
  const val = str.toString().slice(-n);
  //   if string length is less than n, return the whole string otherwise return the last n digits with .. in front
  return str.length < n ? str : '..' + val;
};

export const fData = (number: number) => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let unit = 0;
  while (number >= 1024) {
    number /= 1024;
    unit++;
  }
  return `${number.toFixed(1)} ${units[unit]}`;
};

export const fText = (text: string, len: number) => {
  if (text.length > len) return `${text.slice(0, len)}...`;
  return text;
};
